import EDTypography, {
  ITypographyProps,
} from '../../../BaseComponents/Typography/EDTypography';

import { ValueType } from '../../../Utils/Formatters/FormatterTypes';
import { BaseDisplayer } from '../../../Utils/Formatters/Displayers/BaseDisplayer';
import { DisplayCompType } from '../../../Features/Delsystem/_Common/Const/BusinessConfigs';
import EDTextLines from '../../../BaseComponents/TextLines/EDTextLines';
import { MASKED_VALUE_TEXT } from '../../../Features/Delsystem/_Common/Hooks/useAttributeValues';

interface IProps extends Omit<ITypographyProps, 'ref'> {
  value: ValueType;
  displayer: BaseDisplayer;
  displayComp?: DisplayCompType;
  params?: string;
  testId?: string;
  /** Character rendered if value is falsy */
  noValueChar?: string;
  masked?: boolean;
}

const DisplayText = (props: IProps) => {
  const {
    value,
    displayer,
    params,
    displayComp: DisplayComp,
    testId,
    noValueChar,
    lineHeight,
    masked,
    ...rest
  } = props;
  const displayValue = masked
    ? MASKED_VALUE_TEXT
    : (displayer.display(value, true, params) || noValueChar) ?? '';
  // FIXME: Marcus: Hur används denna, någon får visa.
  return (
    <EDTypography data-testid={testId} lineHeight={lineHeight ?? 1.2} {...rest}>
      {DisplayComp ? (
        <DisplayComp value={value} displayValue={displayValue} />
      ) : (
        <EDTextLines lines={displayValue.split('\n')} />
      )}
    </EDTypography>
  );
};

export default DisplayText;
